import { cookieStorage } from '../utils/cookieStorage';
// src/services/permissionService.ts

import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL = 'route-permissions/'; // ruta relativa, baseURL ya apunta a /api/

const API_URL_LEVEL = 'userlevels/';

export interface RoutePerm {
    id: number;
    path: string;
    activo?: boolean;
    allowed_roles: string[]; // nombres de UserLevel
}

// GET: Obtener todas las reglas de permiso
export const fetchRoutePermissions = async (): Promise<RoutePerm[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<RoutePerm[]>(API_URL);
        return response.data;
    });
};

// POST: Crear una nueva regla de permiso
export const createRoutePermission = async (data: {
    path: string;
    allowed_roles: string[];
    activo?: boolean;
}): Promise<RoutePerm> => {
    return handleRequestWithAuth(async () => {
        try {
            const response = await axiosInstance.post<RoutePerm>(API_URL, data);
            cookieStorage.setItem('comarca_route_permissions_revision', `${Date.now()}-${Math.random()}`);
            window.dispatchEvent(new CustomEvent('route-permissions-changed', {detail: {permission: response.data}}));
            return response.data;
        } catch (error: any) {
            console.error("Error en createRoutePermission:", error.response?.data || error.message);
            throw error;
        }
    });
};


// PUT: Actualizar una regla existente
export const updateRoutePermission = async (
    id: number,
    data: {
        path?: string;
        allowed_roles?: string[];
        activo?: boolean;
    }
): Promise<RoutePerm> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.put<RoutePerm>(`${API_URL}${id}/`, data);
        cookieStorage.setItem('comarca_route_permissions_revision', `${Date.now()}-${Math.random()}`);
        window.dispatchEvent(new CustomEvent('route-permissions-changed', {detail: {permission: response.data}}));
        return response.data;
    });
};

// DELETE: Eliminar una regla de permiso
export const deleteRoutePermission = async (id: number): Promise<void> => {
    return handleRequestWithAuth(async () => {
        await axiosInstance.delete(`${API_URL}${id}/`);
        cookieStorage.setItem('comarca_route_permissions_revision', `${Date.now()}-${Math.random()}`);
        window.dispatchEvent(new CustomEvent('route-permissions-changed', {detail: {deletedId: id}}));
    });
};


// GET: Obtener todos los UserLevels
export const fetchUserLevels = async (): Promise<string[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get<any[]>(API_URL_LEVEL);
        return response.data.map(level => level.nombre);
    });
};

export const setRoutePermissionActive = (id: number, activo: boolean): Promise<RoutePerm> =>
    handleRequestWithAuth(async () => {
        const response = await axiosInstance.patch<RoutePerm>(`${API_URL}${id}/`, {activo});
        cookieStorage.setItem('comarca_route_permissions_revision', `${Date.now()}-${Math.random()}`);
        window.dispatchEvent(new CustomEvent('route-permissions-changed', {detail: {permission: response.data}}));
        return response.data;
    });
